import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle, RefreshCcw } from "lucide-react";
import { markOrderCancelled } from "../services/orderPayment";

/**
 * /error — Epoint redirects here after a failed / cancelled / declined charge.
 * We simply flip the Firestore order from `awaiting_payment` → `cancelled` so
 * the user can place a new order. Cart is intentionally NOT cleared (so the
 * buyer can retry immediately).
 */
export default function PaymentErrorPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("processing");
  const [trackingNo, setTrackingNo] = useState("");

  const orderId = params.get("order_id") || params.get("o") || params.get("tracking_no") || "";
  const reason = params.get("message") || params.get("description") || "";

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!orderId) {
        if (!cancelled) setStatus("done");
        return;
      }
      try {
        const found = await markOrderCancelled(orderId, reason ? { failure_reason: reason } : {});
        if (found) setTrackingNo(found.data.tracking_no || orderId);
        // Cleanup any parked pending actions so they don't get applied later.
        try {
          localStorage.removeItem(`epoint_pending_${orderId}`);
          localStorage.removeItem(`epoint_txn_${orderId}`);
        } catch { /* ignore */ }
      } catch (e) {
        console.warn(e);
      } finally {
        if (!cancelled) setStatus("done");
      }
    }
    run();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  return (
    <div className="bg-[var(--bg)] min-h-[70vh]">
      <section className="container-base py-20">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-20 h-20 mx-auto rounded-full bg-[var(--surface)] border border-[var(--text-2)] flex items-center justify-center text-[var(--text-2)] mb-6">
            <XCircle size={42} />
          </div>
          <h1 className="font-display text-4xl md:text-5xl mb-4">Ödəniş alınmadı</h1>
          <p className="text-[var(--text-2)] mb-2">
            {status === "processing"
              ? "Sifariş statusu yenilənir…"
              : trackingNo
              ? <>Sifariş <span className="font-mono">{trackingNo}</span> ləğv edildi.</>
              : "Sifariş ləğv edildi."}
          </p>
          {reason && <p className="text-sm text-[var(--text-muted)] mb-6">Səbəb: {reason}</p>}
          <p className="text-[var(--text-2)] mb-6">Səbətiniz hələ də saxlanılıb — yenidən cəhd edə bilərsiniz.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/checkout" className="btn-primary inline-flex items-center gap-2">
              <RefreshCcw size={16} /> Yenidən ödə
            </Link>
            <Link to="/cart" className="btn-outline">Səbətə qayıt</Link>
            <Link to="/catalog" className="btn-outline">Kataloqa qayıt</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
